export interface Collective {
  id: string
  companyName: string
}
